module.exports = __webpack_public_path__ + "static/media/line_connect_success.7970818e.png";